import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  SafIcon,
  SafMenuItem,
  SafSideNav,
} from "@saffron/core-components/react";
import "../../css/sidenav.css";

const SideNav = () => {
  const location = useLocation();
  const [currentAssetId, setCurrentAssetId] = useState(null);

  useEffect(() => {
    const pathMatch = location.pathname.match(
      /^\/([^/]+)\/(?:summary|architecture-details|technology-stacks|cloud-permit)/
    );
    if (pathMatch && pathMatch[1]) {
      setCurrentAssetId(pathMatch[1]);
    } else {
      setCurrentAssetId(null);
    }
  }, [location.pathname]);

  // Default pages that show the main navigation
  const isDefaultPage = ["/home", "/asset-insight"].includes(location.pathname);

  const isSpecialPage = [
    "/runtime",
    "/customruntime",
    "/technology-stacks/addtechstack",
    "/technology-stacks/addbackendtechstack",
    "/technology-stacks/adddevopstechstack",
  ].includes(location.pathname);

  return (
    <div
      style={{
        position: "relative",
        zIndex: 900,
        top: "54px",
        background: "white",
      }}
    >
      {isSpecialPage ? null : currentAssetId && !isDefaultPage ? (
        <SafSideNav
          id="sidenav"
          state="open"
          aria-label="Side navigation"
          close-aria-label="Collapse side nav"
          open-svg-name="arrow-right-from-line"
          close-svg-name="arrow-left-from-line"
        >
          {/* These URLs must exactly match the route patterns in app.js */}
          <SafMenuItem
            link-target="_self"
            hasLink
            url={`/${currentAssetId}/summary`}
            style={{
              background: location.pathname.includes("/summary")
                ? "rgba(214, 64, 0, 0.1)"
                : "",
              borderLeft: location.pathname.includes("/summary")
                ? "3px solid #d64000"
                : "",
              color: location.pathname.includes("/summary") ? "#d64000" : "",
            }}
          >
            Summary
          </SafMenuItem>
          <SafMenuItem
            link-target="_self"
            hasLink
            url={`/${currentAssetId}/architecture-details`}
            style={{
              background: location.pathname.includes("/architecture-details")
                ? "rgba(214, 64, 0, 0.1)"
                : "",
              borderLeft: location.pathname.includes("/architecture-details")
                ? "3px solid #d64000"
                : "",
              color: location.pathname.includes("/architecture-details")
                ? "#d64000"
                : "",
            }}
          >
            Architecture Details
          </SafMenuItem>
          <SafMenuItem
            link-target="_self"
            hasLink
            url={`/${currentAssetId}/technology-stacks`}
            style={{
              background: location.pathname.includes("/technology-stacks")
                ? "rgba(214, 64, 0, 0.1)"
                : "",
              borderLeft: location.pathname.includes("/technology-stacks")
                ? "3px solid #d64000"
                : "",
              color: location.pathname.includes("/technology-stacks")
                ? "#d64000"
                : "",
            }}
          >
            Technology Stacks
          </SafMenuItem>
          <SafMenuItem
            link-target="_self"
            hasLink
            url={`/${currentAssetId}/cloud-permit`}
            style={{
              background: location.pathname.includes("/cloud-permit")
                ? "rgba(214, 64, 0, 0.1)"
                : "",
              borderLeft: location.pathname.includes("/cloud-permit")
                ? "3px solid #d64000"
                : "",
              color: location.pathname.includes("/cloud-permit")
                ? "#d64000"
                : "",
            }}
          >
            Cloud Permit
          </SafMenuItem>
        </SafSideNav>
      ) : (
        <>
          <SafSideNav
            id="sidenav"
            state="open"
            aria-label="Side navigation"
            close-aria-label="Collapse side nav"
            open-svg-name="arrow-right-from-line"
            close-svg-name="arrow-left-from-line"
          >
            <SafMenuItem link-target="_self" hasLink url="/home">
              <SafIcon iconName="books" slot="start"></SafIcon>
              Asset Library
            </SafMenuItem>
            <SafMenuItem
              hasLink
              url="https://assets.int.thomsonreuters.com/"
              target="_blank"
            >
              <SafIcon iconName="compass" slot="start"></SafIcon>
              Asset Insight &nbsp;
              <SafIcon iconName="external-link"></SafIcon>
            </SafMenuItem>
          </SafSideNav>
        </>
      )}
    </div>
  );
};

export default SideNav;
